import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    root: {
        width: '100%',
        borderBottom: '1px solid #fab74c',
        margin: '16px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
    rootPaper: {
        minHeight: 'calc(100% - 48px)',
        margin: '24px',
        [theme.breakpoints.down('sm')]: {
            width: 'calc(98% - 48px)',
        },
        ...theme.paperPadding,
    },
    subUnderline: {
        width: '100%',
        borderRight: '5px solid transparent',
        borderBottom: '5px solid #f6660d',
    },
    subUnderlineBox: {
        position: 'absolute',
        bottom: 0,
        paddingRight: '15px',
        width: '100%',
    },
    title: {
        fontFamily: 'DB_Ozone',
        margin: '0px',
        fontSize: '34px',
        fontWeight: 700,
        lineHeight: 1,
        color: '#f5650c',
        borderRight: '3px solid transparent',
        borderBottom: '3px solid #fbb84d',
        paddingRight: '30px',
        paddingBottom: '14px',
    },
    titleBox: {
        position: 'relative',
        display: 'inline-block',
    },
    subText: {
        fontSize: '32px',
        color: '#fbb84d',
        paddingBottom: '5px',
    },
    underTitleText: {
        fontSize: '24px',
        fontWeight: 400,
        paddingBottom: '5px',
        fontFamily: 'DBChuanPimX',
        color: 'rgba(66, 66, 66, 1)',
    },
});

const TitleWithUnderline = ({
    style = {},
    title = '',
    styleRoot = {},
    subText = '',
    underTitleText = '',
    children,
    size = 'normal',
    classes,
}) => {
    return (
        <div className={classes.root}>
            <div className={classes.titleBox}>
                <div className={classes.title}>
                    {title}
                    {underTitleText && (
                        <div className={classes.underTitleText}>
                            {underTitleText}
                        </div>
                    )}
                </div>
                <div className={classes.subUnderlineBox}>
                    <div className={classes.subUnderline} />
                </div>
            </div>
            {subText && <div className={classes.subText}>{subText}</div>}
            {children}
        </div>
    );
};
export default withStyles(styles)(TitleWithUnderline);
